import { render, staticRenderFns } from "./PodcastSection.vue?vue&type=template&id=3494b9c3&scoped=true&"
import script from "./PodcastSection.vue?vue&type=script&lang=js&"
export * from "./PodcastSection.vue?vue&type=script&lang=js&"
import style0 from "./PodcastSection.vue?vue&type=style&index=0&id=3494b9c3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3494b9c3",
  null
  
)

export default component.exports